import React, { useState } from 'react';
import { useAuth, ROLES } from '../context/AuthContext';
import { useToast } from '../components/Toast';
import Modal from '../components/Modal';

const ROL_COLORS = {
  'Administrador':       { background: '#ede9fe', color: '#7c3aed' },
  'Técnico de Servicio': { background: '#dbeafe', color: '#1d4ed8' },
  'Técnico Instalador':  { background: '#cffafe', color: '#0e7490' },
  'Vendedor':            { background: '#dcfce7', color: '#16a34a' },
  'Mostrador':           { background: '#fef3c7', color: '#b45309' }
};

export default function Usuarios() {
  const { user, users, addUser, updateUser, removeUser } = useAuth();
  const toast = useToast();
  const [modal, setModal] = useState(null); // {modo:'nuevo'|'editar', data}

  const guardar = (data) => {
    if (!data.nombre.trim() || !data.usuario.trim() || !data.password) {
      toast.show('Completa nombre, usuario y contraseña', 'error');
      return;
    }
    if (modal.modo === 'nuevo') {
      if (users.some(u => u.usuario.toLowerCase() === data.usuario.toLowerCase())) {
        toast.show('Ese usuario ya existe', 'error');
        return;
      }
      addUser(data);
      toast.show('Usuario creado');
    } else {
      updateUser(modal.data.id, data);
      toast.show('Usuario actualizado');
    }
    setModal(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
        <h1 style={{ fontSize: 20, fontWeight: 800, marginRight: 'auto' }}>Usuarios</h1>
        <button className="btn-primary" onClick={() => setModal({ modo: 'nuevo', data: { nombre: '', usuario: '', password: '', rol: 'Mostrador' } })}>
          + Nuevo usuario
        </button>
      </div>

      <div className="card table-wrap" style={{ overflow: 'auto' }}>
        <table>
          <thead>
            <tr><th>Nombre</th><th>Usuario</th><th>Rol</th><th></th></tr>
          </thead>
          <tbody>
            {users.map(u => {
              const col = ROL_COLORS[u.rol] || { background: '#f1f5f9', color: '#475569' };
              return (
                <tr key={u.id}>
                  <td style={{ fontWeight: 600 }}>{u.nombre}{u.id === user.id && <span style={{ color: '#94a3b8', fontWeight: 500 }}> (tú)</span>}</td>
                  <td>{u.usuario}</td>
                  <td><span style={{ ...col, padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 700 }}>{u.rol}</span></td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn-secondary" style={{ padding: '5px 10px', fontSize: 13, marginRight: 6 }}
                      onClick={() => setModal({ modo: 'editar', data: u })}>Editar</button>
                    {u.id !== user.id && (
                      <button className="btn-danger" style={{ padding: '5px 10px', fontSize: 13 }}
                        onClick={() => { if (window.confirm('¿Eliminar a ' + u.nombre + '?')) { removeUser(u.id); toast.show('Usuario eliminado'); } }}>
                        Eliminar
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal title={modal.modo === 'nuevo' ? 'Nuevo usuario' : 'Editar usuario'} onClose={() => setModal(null)}>
          <UserForm data={modal.data} onSave={guardar} />
        </Modal>
      )}
    </div>
  );
}

function UserForm({ data, onSave }) {
  const [f, setF] = useState({ nombre: data.nombre, usuario: data.usuario, password: data.password, rol: data.rol });
  const set = (k, v) => setF(prev => ({ ...prev, [k]: v }));
  const L = ({ children }) => <label style={{ fontSize: 13, fontWeight: 600, color: '#475569', display: 'block', margin: '10px 0 5px' }}>{children}</label>;
  return (
    <div>
      <L>Nombre</L>
      <input type="text" value={f.nombre} onChange={e => set('nombre', e.target.value)} />
      <L>Usuario (para iniciar sesión)</L>
      <input type="text" value={f.usuario} onChange={e => set('usuario', e.target.value)} />
      <L>Contraseña</L>
      <input type="text" value={f.password} onChange={e => set('password', e.target.value)} />
      <L>Rol</L>
      <select value={f.rol} onChange={e => set('rol', e.target.value)}>
        {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
      </select>
      <button className="btn-primary" style={{ width: '100%', marginTop: 16 }} onClick={() => onSave(f)}>Guardar</button>
    </div>
  );
}
